import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { UpdateMyAnalyticsSettingsInput } from '@/gql/graphql';
import { useMutation } from '@tanstack/react-query';

const UpdateMyAnalyticsSettingsMutation = graphql(`
  mutation UpdateMyAnalyticsSettings($input: UpdateMyAnalyticsSettingsInput!) {
    updateMyAnalyticsSettings(input: $input)
  }
`);

export const useUpdateMyAnalyticsSettings = () => {
  return useMutation({
    mutationFn: (input: UpdateMyAnalyticsSettingsInput) => {
      return gqlClient.request(UpdateMyAnalyticsSettingsMutation, {
        input,
      });
    },
  });
};
